// extracted by mini-css-extract-plugin
export default {"duplicateBtn":"DuplicateBtn_duplicateBtn__fhgV-"};